export const isGradientColor = (color: string) => {
  return color?.includes('linear-gradient')
}

export const BG_COLOR = {
  blueDarkest: '#00172F',
  blueDarker: '#0f2441',
  blueDark: '#17263E',
  blueDarkHighlight: '#1A345B',
  blueLight: '#387eff',
  blueLighter: '#44DDCE',
  primaryLight: '#07BFB0',
  buy: '#0AF593',
  sell: '#F5425A',
  buyButton: '#02C076',
  sellButton: '#F5425A',
  primaryDark: '#0a1729',
  primaryDarker: '#081221',
  successFadest: '#52C41A55',
  dangerFadest: '#FF4D4F55',
  successFader: '#52C41A77',
  dangerFader: '#FF4D4F77',
  successFade: '#52C41A99',
  dangerFade: '#FF4D4F99',
  danger: '#FF4D4F',
  success: '#52C41A',
  black: '#081A25',
  blueGrayDarker: '#0D1820',
  blueGray: '#071A22',
  blueGrayLight: '#1F3242',
  blueGrayLighter: '#1E303F',
}
export const TEXT_COLOR = {
  description: '#73808D',
  sell: '#FF5269',
  buy: '#09E187',
  normal: '#D9DCE0',
  placeHolder: '#999999',
  disabled: '#405163',
  gray: '#73808D',
  positiveBestRate: '#d2d5d9',
  green: '#19C6A4',
}
export const BORDER_RADIUS = {
  card: '10px',
  button: '4px',
}

export const MODAL_COLOR = {
  innerContent: '#0A1B29',
  outerContent: '#1E303F',
}

export const CHAIN_COLOR = {
  bsc: '#FCC413',
  '56': '#FCC413',
  polygon: '#A240C9',
  '137': '#A240C9',
  ethereum: '#6065CE',
  '1': '#6065CE',
}
